import styled from '@emotion/styled'

interface Props {
  centered?: boolean
  disabled?: boolean
}

const FormError = styled.span<Props>(
  ({ theme }) => theme.fontSmooth,
  (props) => ({
    display: 'block',
    color: props.theme.colors.danger,
    fontFamily: props.theme.fonts.families.body,
    fontSize: '12px',
    letterSpacing: '0.3px',
    lineHeight: '16px',
    marginBottom: '1em',
    marginTop: '0.4em',
  }),
  (props) =>
    props.disabled && {
      opacity: props.theme.opacities.disabledInput,
    },
  (props) =>
    !!props.centered && {
      textAlign: 'center',
    }
)

export default FormError
